import type {
  Block,
  CalloutData,
} from "../../../../models/ManualAuthoring";

import { useManualAuthoringStore } from "../../../../store/manualAuthoringStore";
import SimpleInlineTextEditor from "../editor/SimpleInlineTextEditor";
import "./caution.css";

export default function CautionEdit({
  block,
  onDone,
}: {
  block: Block;
  onDone: () => void;
}) {
  const updateBlock = useManualAuthoringStore((s) => s.updateBlock);
  const data = block.data as CalloutData;

  return (
    <div className="pdf-block pdf-caution pdf-caution--editing">
      <div className="pdf-caution__header">
        <span className="pdf-caution__symbol">⚠</span>
        <span className="pdf-caution__label">CAUTION</span>
      </div>

      <div className="pdf-caution__content">
        <SimpleInlineTextEditor
          textParts={data.textParts || []}
          onChange={(newParts) => updateBlock(block.id, { textParts: newParts })}
          onDone={onDone}
        />
      </div>
    </div>
  );
}
